import { render, staticRenderFns } from "./_memberVoucherRedeemedLog.vue?vue&type=template&id=588d2aa6&lang=pug"
import script from "./_memberVoucherRedeemedLog.vue?vue&type=script&lang=js"
export * from "./_memberVoucherRedeemedLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports